<script>
import { h, defineComponent, toRef } from 'vue-demi'

const Title = defineComponent({
  name: 'FormilyTitle',
  props: [],
  setup(props, { attrs, slots }) {
    const value = toRef(attrs, 'data')
    return () => {
      return h(
        'div',
        {
          class: [
            { 'formily-title': true },
            { formilyDesc: attrs.formilyDesc },
            { merchantsPadding: attrs.merchantsPadding },
          ],
        },
        [
          h(
            'span',
            {
              class: [{ 'form-item-span': true }],
            },
            [value && value.value],
          ),
        ],
      )
    }
  },
})

export default Title
</script>

<style lang="scss" scoped>
.formily-title {
  padding: 56px 32px 24px;
  .form-item-span {
    font-family: DiDiSans-Pro-Medium;
    font-size: 40px;
    color: #282b33;
    line-height: 40px;
    font-weight: 500;
  }
}
.formilyDesc {
  padding: 0 32px;
  .form-item-span {
    font-family: DiDiSans-Pro-Thin;
    font-size: 24px;
    color: #89898c;
    line-height: 36px;
    font-weight: 200;
  }
}
.merchantsPadding {
  padding: 56px 32px 16px;
}
</style>
